/* tslint:disable */
/* eslint-disable */
/**
 * Umsatzcontrolling
 * Money
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface ImportBerichteRequest {
    requestBody: Array<number>;
}

/**
 * BerichtsmanagementApi - interface
 * 
 * @export
 * @interface BerichtsmanagementApiInterface
 */
export interface BerichtsmanagementApiInterface {
    /**
     * 
     * @summary Importiert (erneut) die angegebenen Berichte aus dem Berichtsmanagement.
     * @param {Array<number>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BerichtsmanagementApiInterface
     */
    importBerichteRaw(requestParameters: ImportBerichteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Importiert (erneut) die angegebenen Berichte aus dem Berichtsmanagement.
     */
    importBerichte(requestParameters: ImportBerichteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class BerichtsmanagementApi extends runtime.BaseAPI implements BerichtsmanagementApiInterface {

    /**
     * Importiert (erneut) die angegebenen Berichte aus dem Berichtsmanagement.
     */
    async importBerichteRaw(requestParameters: ImportBerichteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.requestBody === null || requestParameters.requestBody === undefined) {
            throw new runtime.RequiredError('requestBody','Required parameter requestParameters.requestBody was null or undefined when calling importBerichte.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_auth", []);
        }

        const response = await this.request({
            path: `/api/v1/berichtsmanagement/import`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Importiert (erneut) die angegebenen Berichte aus dem Berichtsmanagement.
     */
    async importBerichte(requestParameters: ImportBerichteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.importBerichteRaw(requestParameters, initOverrides);
    }

}
